import { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Navbar from "./Navbar";
import Footer from "./Footer";

export default function Layout() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname]);

  return (
    <div className="min-h-screen bg-cream-50 text-midnight">
      <Navbar />
      <main className="pt-20 md:pt-24">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}
